import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DashboardService } from 'src/app/services/dashboard.service';


@Component({
    selector: 'app-delete-popup',
    templateUrl: './delete-popup.component.html',
    styleUrls: ['./delete-popup.component.scss'],
    standalone: false // NOSONAR
})
export class DeletePopupComponent implements OnInit {
  dltRes: any;

  constructor(public dialogRef: MatDialogRef<DeletePopupComponent>, private  readonly dashboardService : DashboardService,@Inject(MAT_DIALOG_DATA) public dataStore: any) { }

  ngOnInit(): void {   console.info('something')      }
  close(): void {
    this.dialogRef.close({ event: 'CloseEvent' });
  }
  closeDialog(){
    this.dialogRef.close();
  }

  deleteEvent() {
    this.dashboardService.deleteRow(this.dataStore.eventId,this.dataStore.toyotaGUID)?.subscribe((response) => {
      this.dltRes = response;
      if (this.dltRes == "Event deleted successfully") {   // NOSONAR
        this.dialogRef?.close({
          event: 'SaveEvent',
          responseType: 'success',
        });
      } else {
        console.info('error')
      }
    }, (err) => {
      console.info(err);
    });
  }

}
